import { sleep } from '../lib/tools';
import * as focusTrap from 'focus-trap';

export default class SiteMobileMenu {
  init() {
    
    this.isOpen = false;
    this.trap = focusTrap.createFocusTrap(this.node);

    window.addEventListener('site-mobile-menu__invoke', (e) => {
      this.open();
    });
    
    this.outlets.closeButton.addEventListener('click', () => {
      this.close();
    });

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    });
    
  }

  async open() {
    this.isOpen = true;
    
    this.node.classList.add('state-show');
    
    await sleep(1);
    
    if (!this.isOpen) {
      return;
    }
    
    this.node.classList.add('state-animate');
    
    await sleep(500);

    if (!this.isOpen) {
      return;
    }

    this.trap.activate();
  }

  async close() {
    this.isOpen = false;
    
    this.node.classList.remove('state-animate');
    
    await sleep(500);
    
    if (this.isOpen) {
      return;
    }
    
    this.trap.deactivate();

    this.node.classList.remove('state-show');
    
    await sleep(1);
  }
}
